// Model is now fixed to Pro (Gemini 3 Pro Preview) - no user selection needed
// This file provides the model ID and compatibility exports

export type ModelTier = 'pro';

export const PRO_MODEL_ID = 'google/gemini-3-pro-preview';

// Keep these exports for backward compatibility with existing code
export const getModelId = (_tier?: ModelTier): string => {
  return PRO_MODEL_ID;
};

export const DEFAULT_MODEL_TIER: ModelTier = 'pro';
export const DEFAULT_MODEL_ID = PRO_MODEL_ID;

// Empty component - no longer renders anything since we don't need model selection
export const ModelSelector = () => null;
